import { styled } from "@mui/material/styles";
const QuoteApprovedMain = styled("div")(({ theme }) => ({
  marginTop: "35px",
  paddingBottom: "40px",
  [theme.breakpoints.down("md")]: {
    paddingBottom: "30px",
  },
}));
const PreviewOrderHeader = styled("div")(({ theme }) => ({
  textAlign: "center",
  "& h6": {
    fontFamily: theme.typography.fontFamily,
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "32px",
    lineHeight: "44px",
    textAlign: "center",
    color: theme.palette.colors.BlackBean,
  },
  "& p": {
    fontFamily: theme.typography.fontFamily,
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "22px",
    lineHeight: "30px",
    textAlign: "center",
    color: "rgba(11, 11, 11, 0.5)",
  },
  [theme.breakpoints.down("md")]: {
    "& h6": { fontWeight: 900, fontSize: "20px" },
    "& p": { fontSize: "16px", lineHeight: "21px" },
  },
}));
const QuoteItem = styled("div")(({ theme }) => ({
  width: "80%",
  margin: "auto",
  marginTop: "50px",
  "& .Quote_ItemMain": {
    display: "flex",
    alignItems: "center",
    marginBottom: "15px",
    gap: "20px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "20.7649px",
      lineHeight: "28px",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
  },
  "& .date_ItemMain": {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "15px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "20px",
      lineHeight: "28px",
      color: "rgba(11, 11, 11, 0.75)",
      fontFamily: theme.typography.fontFamily,
    },
  },
  "& .many_orders": {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "15px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "20px",
      lineHeight: "28px",
      color: "rgba(11, 11, 11, 0.75)",
      fontFamily: theme.typography.fontFamily,
    },
  },
  "& .orders_image": {
    display: "flex",
    alignItems: "start",
    gap: "20px",
    marginBottom: "15px",
    "& img.orderImg": {
      width: "92px",
      height: "69px",
      borderRadius: "5px",
    },
  },
  "& .pickup_ItemMain": {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "20px",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      left: "3%",
      top: "100%",
      height: "64%",
      width: "1px",
      borderLeft: "2px dashed rgba(11, 11, 11, 0.5)",
    },
    "& span": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "20.7649px",
      lineHeight: "130%",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
  },
  "& .drop_ItemMain": {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "15px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "20.7649px",
      lineHeight: "130%",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    "& .Quote_ItemMain": {
      marginBottom: "10px",
      gap: "10px",
      "& span": {
        fontSize: "16px",
      },
    },
    "& .date_ItemMain": {
      gap: "10px",
      marginBottom: "10px",
      "& span": {
        fontSize: "16px",
      },
    },
    "& .many_orders": {
      gap: "10px",
      marginBottom: "10px",
      "& span": {
        fontSize: "16px",
      },
    },
    "& .orders_image": {
      gap: "10px",
      marginBottom: "10px",
      "& img.orderImg": {
        width: "80px",
        height: "60px",
        borderRadius: "5px",
      },
    },
    "& .pickup_ItemMain": {
      gap: "10px",
      marginBottom: "20px",
      "&::after": {
        left: "3.5%",
      },
      "& span": {
        fontSize: "16px",
      },
    },
    "& .drop_ItemMain": {
      gap: "10px",
      marginBottom: "10px",
      "& span": {
        fontSize: "16px",
      },
    },
  },
}));
const SuccessmarkImg = styled("img")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
  [theme.breakpoints.down("md")]: {
    display: "block",
    margin: "auto",
  },
}));

export { QuoteApprovedMain, PreviewOrderHeader, QuoteItem, SuccessmarkImg };
